export default "__VITE_PUBLIC_ASSET__82c32af9__"